
              var key = '__global_unique_id__';

              export default function() {
                return global[key] = (global[key] || 0) + 1;
              };
            